export default function (value, minimumFractionDigits = 0, maximumFractionDigits = 2) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
    });
    return formatter.format(value);
}
